"use client";
import { jsx } from "react/jsx-runtime";
import React from "react";
import cx from "classnames";
const ScrollIndicator = React.forwardRef(
  (props, ref) => {
    const {
      prefix,
      barPosition,
      barWidth,
      onClick,
      onMouseDown,
      draggable,
      ...other
    } = props;
    const positionPercentage = barPosition - barWidth * barPosition / 100;
    const barScale = 100 / barWidth;
    const barPositionScaled = positionPercentage * barScale;
    const barClasses = cx(
      `${prefix}scroll-indicator__bar`,
      draggable && `${prefix}scroll-indicator__bar-dragging`
    );
    const scrollIndicatorClassess = cx(
      `${prefix}scroll-indicator`,
      draggable && `${prefix}scroll-indicator--dragging`
    );
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: scrollIndicatorClassess,
        onClick: (e) => onClick && onClick(e),
        "aria-hidden": true,
        ...other,
        children: barWidth > 0 && /* @__PURE__ */ jsx("span", { className: `${prefix}scroll-indicator__bar-wrapper`, ref, children: /* @__PURE__ */ jsx(
          "span",
          {
            className: barClasses,
            style: {
              width: `${barWidth}%`,
              transform: `translateX(${barPositionScaled}%)`
            },
            onMouseDown: (e) => onMouseDown && onMouseDown(e)
          }
        ) })
      }
    );
  }
);
ScrollIndicator.displayName = "ScrollIndicator";
var ScrollIndicator_default = ScrollIndicator;
export {
  ScrollIndicator_default as default
};
